import type { ReactNode } from 'react'
import { stateTone } from '@/lib/format'

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string
  subtitle?: string
  actions?: ReactNode
}) {
  return (
    <div className="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  )
}

export function Card({
  title,
  children,
  actions,
}: {
  title?: string
  children: ReactNode
  actions?: ReactNode
}) {
  return (
    <section className="card">
      {(title || actions) && (
        <div className="card-head">
          {title && <h2>{title}</h2>}
          {actions}
        </div>
      )}
      <div className="card-body">{children}</div>
    </section>
  )
}

export function Stat({
  label,
  value,
  hint,
  tone,
}: {
  label: string
  value: ReactNode
  hint?: string
  tone?: 'ok' | 'warn' | 'error' | 'idle'
}) {
  return (
    <div className={`stat stat-${tone ?? 'idle'}`}>
      <span className="stat-label">{label}</span>
      <span className="stat-value">{value}</span>
      {hint && <span className="stat-hint">{hint}</span>}
    </div>
  )
}

export function Badge({ state }: { state: string | null | undefined }) {
  if (!state) return <span className="badge badge-idle">—</span>
  return <span className={`badge badge-${stateTone(state)}`}>{state}</span>
}

/** Consistent placeholder for the empty / loading / failed states. */
export function DataState({
  loading,
  error,
  empty,
  emptyMessage = 'Nothing to show yet.',
}: {
  loading: boolean
  error: string | null
  empty: boolean
  emptyMessage?: string
}) {
  if (error) return <div className="notice notice-error">{error}</div>
  if (loading) return <div className="notice">Loading…</div>
  if (empty) return <div className="notice">{emptyMessage}</div>
  return null
}
